export const SELECTORS = {
  FORM_CONTAINER: 'js-zapier-form-container',
  FORM: 'js-zapier-form',
  SUBMIT_BUTTON: 'js-zapier-form-submit-button',
  SUCCESS_MESSAGE: 'js-zapier-form-success-message',
  CONTENT: 'js-zapier-form-content',
  ERROR_MESSAGE: 'js-zapier-form-error-message'
};

export const COOKIE_KEY = 'zapier-form';
